module.exports = __webpack_public_path__ + "img/I3-071211-1148-Sasm01.CATProduct.4796e84c.jpg";